<div class="modal-content wizard-main-content">
  <div class="row">
    <div class="col-11">
      @if(isMacRDPEnabled) {
        <p class="wizard-title">Setup Your Computer</p>
      }
      @else {
        <p class="wizard-title">Download and Run Setup Wizard</p>
      }
    </div>
    <div class="col-1">
      @if(isMacRDPEnabled) {
        <rw-button
          buttonclass="btn-close"
          datapendoid="btnDownloadSetupWizClose"
          datatestid="btnDownloadSetupWizClose"
          arialabel="Download Setup Wizard close button"
          (clickButton)="close()">
        </rw-button>
      }
      @else {
        <button
          type="button"
          data-testid="btnDownloadSetupWizClose"
          class="close close-wizard"
          (click)="close()"
        >
          <app-icon [source]="'rn-x'"></app-icon>
        </button>
      }
    </div>
  </div>
  @if(isMacRDPEnabled) {
  <hr />
  }

  @if(!isMacRDPEnabled) {
    <div class="row">
      <div class="col-10">
        <p class="wizard-subtitle">
          The Rightworks Setup Wizard configures your PC or Mac to connect to your
          new cloud-hosted remote desktop. It will also setup your computer to
          print and scan. Select your computer platform to get started.
        </p>
      </div>
    </div>
  }

  <div class="row">
    <div class="col-6">
      <div class="wizard-box left">
        <div class="row">
          <div class="col-12">
            @if(isMacRDPEnabled) {
              <div class="wizard-card-title">
                PC Download
              </div>
            }
            @else {
              <div class="wizard-logo">
                <img
                  alt="Download button image"
                  style="max-width: 100%"
                  src="{{ asset_url }}/images/DownloadButton_Windows_Angular.png"
                />
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="wizard-text">
              @if(isMacRDPEnabled) {
                To configure your PC, download and follow the wizard's instructions.
              }
              @else {
                Download the Setup Wizard, launch it, and follow the instructions
                to configure your computer.
              }
            </div>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="wizard-button-div">
              @if(isMacRDPEnabled) {
                <app-button
                  id="btnDownloadSetupWizardWindows"
                  buttonStyle="primary"
                  label="download pc wizard"
                  showIcon="true"
                  isImageBackward="true"
                  imgSource="rn-download"
                  imgClass="filter-white"
                  (clickActionEmitter)="trackWindowsDownload()"
                >
                </app-button>
              }
              @else {
                <app-button
                  id="btnDownloadSetupWizardWindows"
                  buttonStyle="primary"
                  label="DOWNLOAD"
                  showIcon="true"
                  isImageBackward="true"
                  imgSource="rn-download"
                  imgClass="filter-white"
                  (clickActionEmitter)="trackWindowsDownload()"
                  placement="right"
                  tt_datatestid="setupwizard-downloadwindows-tooltip"
                  tt_datapendoid="setupwizard-downloadwindows-tooltip"
                  tt_arialabel="Setup wizard download windows tooltip"
                  rw-tooltip="Download and run the Setup Wizard for your PC."
                >
                </app-button>
              }
            </div>
          </div>
        </div>
        @if(!isMacRDPEnabled) {
          <div class="row">
            <div class="col-12">
              <div class="wizard-help">
                <a
                  tabindex="0"
                  (keyup.enter)="getWindowsHelp()"
                  class="getHelpSetupWiz"
                  (click)="getWindowsHelp()"
                  placement="right"
                  tt_datatestid="setupwizard-windowshelp-tooltip"
                  tt_datapendoid="setupwizard-windowshelp-tooltip"
                  tt_arialabel="Setup wizard windows help tooltip"
                  rw-tooltip="Watch a video to get help on the setup."
                  >Get Help</a
                >
              </div>
            </div>
          </div>
        }
      </div>
    </div>
    <div class="col-6">
      <div class="wizard-box right">
        <div class="row">
          <div class="col-12">
            @if(isMacRDPEnabled) {
              <div class="wizard-card-title">
                MAC Download
              </div>
            }
            @else {
              <div class="wizard-logo">
                <img
                  alt="Download Button image"
                  style="max-width: 100%"
                  src="{{ asset_url }}/images/DownloadButton_Mac_Angular.png"
                />
              </div>
            }
          </div>
        </div>
        <div class="row">
          <div class="col-1"></div>
          <div class="col-10">
            <div class="wizard-text">
              @if(isMacRDPEnabled) {
                To configure your MAC, review the following knowledge base article,
                and then download the remote desktop file.
              }
              @else {
                Download the Setup Wizard, launch it, and follow the instructions
                to configure your computer.
              }
            </div>
          </div>
          <div class="col-1"></div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="wizard-button-div">
              @if(isMacRDPEnabled) {
                <app-button
                  id="btnMacKnowledgeBase"
                  buttonStyle="primary"
                  label="go to knowledge base"
                  showIcon="true"
                  isImageBackward="true"
                  imgSource="rn-link-external"
                  imgClass="filter-white"
                  (clickActionEmitter)="openMacKnowledgeBase()"
                >
                </app-button>
                <app-button
                  id="btnDownloadMacRDP"
                  buttonStyle="primary"
                  label="download rdp for mac"
                  showIcon="true"
                  isImageBackward="true"
                  imgSource="rn-download"
                  imgClass="filter-white"
                  (clickActionEmitter)="downloadRDP()"
                >
                </app-button>
              }
              @else {
                <app-button
                  id="btnDownloadSetupWizardMac"
                  buttonStyle="primary"
                  label="DOWNLOAD"
                  showIcon="true"
                  imgSource="rn-download"
                  imgClass="filter-white"
                  (clickActionEmitter)="trackMacDownload()"
                  placement="right"
                  tt_datatestid="setupwizard-downloadmac-tooltip"
                  tt_datapendoid="setupwizard-downloadmac-tooltip"
                  tt_arialabel="Setup wizard download mac tooltip"
                  rw-tooltip="Download and run the Setup Wizard for your Mac."
                >
                </app-button>
              }
            </div>
          </div>
        </div>
        @if(!isMacRDPEnabled) {
          <div class="row">
            <div class="col-12">
              <div class="wizard-help">
                <a
                  tabindex="0"
                  (keyup.enter)="getMacHelp()"
                  class="getHelpSetupWiz"
                  data-testid="btnDownloadSetupWizGetMacHelp"
                  (click)="getMacHelp()"
                  placement="right"
                  tt_datatestid="setupwizard-machelp-tooltip"
                  tt_datapendoid="setupwizard-machelp-tooltip"
                  tt_arialabel="Setup wizard mac help tooltip"
                  rw-tooltip="Visit our Knowledge Base to get help on the setup"
                  >Get Help</a
                >
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="wizard-note">
        Get setup help for your <a class="z-index-2000"
         target="_blank"
         rel="noreferrer"
         href="https://helpdesk.rightnetworks.com/s/article/Connect-from-an-iPhone-iPad">iPhone or iPad</a>, <a
          class="z-index-2000"
          target="_blank"
          rel="noreferrer"
          href="https://helpdesk.rightnetworks.com/s/article/Connect-from-an-Android-Device">Android</a>, or <a class="z-index-2000"
           target="_blank"
           rel="noreferrer"
           href="https://helpdesk.rightnetworks.com/s/article/Connect-from-a-Google-Chromebook">Chromebook</a>. <br />
        (At this time, we do not have a setup wizard to connect these devices to your desktop.)
      </div>
    </div>
  </div>
</div>
